import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from './redux/slices/authSlice';

import ProtectedRoute from './components/common/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Transactions from './pages/Transactions';
import Users from './pages/Users';
import Webhooks from './pages/Webhooks';
import IpWhitelist from './pages/IpWhitelist';
import WebhookLogs from './pages/WebhookLogs';
import Profile from './pages/Profile';
import Settings from './pages/Settings';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token && isAuthenticated) {
      dispatch(getProfile());
    }
  }, [dispatch, token, isAuthenticated]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/projects"
        element={
          <ProtectedRoute requiredPermission="manage_projects">
            <Projects />
          </ProtectedRoute>
        }
      />

      <Route
        path="/transactions"
        element={
          <ProtectedRoute requiredPermission="view_transactions">
            <Transactions />
          </ProtectedRoute>
        }
      />

      <Route
        path="/users"
        element={
          <ProtectedRoute requiredRole="admin">
            <Users />
          </ProtectedRoute>
        }
      />

      <Route
        path="/webhooks"
        element={
          <ProtectedRoute requiredPermission="manage_webhooks">
            <Webhooks />
          </ProtectedRoute>
        }
      />

      <Route
        path="/ip-whitelist"
        element={
          <ProtectedRoute requiredPermission="manage_ip_whitelist">
            <IpWhitelist />
          </ProtectedRoute>
        }
      />

      <Route
        path="/webhook-logs"
        element={
          <ProtectedRoute requiredPermission="view_logs">
            <WebhookLogs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
